import { render } from "./VentaDigital.vue?vue&type=template&id=2ccc685b&scoped=true"
import script from "./VentaDigital.vue?vue&type=script&lang=js"
export * from "./VentaDigital.vue?vue&type=script&lang=js"

import "./VentaDigital.vue?vue&type=style&index=0&id=2ccc685b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ccc685b"]])

export default __exports__